import { Route as RootRoute } from '@/routes/__root';
import {
  IndexRoute as ConfigurationIndexRoute,
  Route as ConfigurationRoute,
  CountryRisksRoute,
} from '@/routes/configuration';
import { Route as LotSizingRoute } from '@/routes/lot-sizing.$id';
import { Route as LotSizingsRoute } from '@/routes/lot-sizings';
import { Route as ProductionDeclarationRoute } from '@/routes/production-declarations/production-declarations.$id';
import { Route as ProductionDeclarationGuidelineRoute } from '@/routes/production-declarations/production-declarations.$id.guideline';
import { Route as ProductionDeclarationMaterialRoute } from '@/routes/production-declarations/production-declarations.$id.materials.$materialId';
import { Route as ProductionDeclarationStatementRoute } from '@/routes/production-declarations/production-declarations.$id.statement';
import { Route as ProductionDeclarationSubmissionRoute } from '@/routes/production-declarations/production-declarations.$id.submission';
import { Route as PurchaseOrdersRoute } from '@/routes/purchase-orders';
import { Route as PurchaseOrderRoute } from '@/routes/purchase-orders.$id';
import { Route as PurchaseOrderActivityRoute } from '@/routes/purchase-orders.$id.activity';
import { Route as PurchaseOrderDocumentsRoute } from '@/routes/purchase-orders.$id.documents';
import { Route as PurchaseOrderMainRoute } from '@/routes/purchase-orders.$id.main';
import { Route as PurchaseOrderProductsRoute } from '@/routes/purchase-orders.$id.products';
import { Route as PurchasePlanningRoute } from '@/routes/purchase-planning';
import { Route as SettingsRoute } from '@/routes/settings';
import { Route as TransitsRoute } from '@/routes/transits';
import { Route as TransitDetailRoute } from '@/routes/transits.$id';

export const routeTree = RootRoute.addChildren([
  PurchasePlanningRoute,
  LotSizingsRoute,
  LotSizingRoute,
  PurchaseOrdersRoute,
  ProductionDeclarationRoute.addChildren([
    ProductionDeclarationGuidelineRoute,
    ProductionDeclarationMaterialRoute,
    ProductionDeclarationStatementRoute,
    ProductionDeclarationSubmissionRoute,
  ]),
  PurchaseOrderRoute.addChildren([
    PurchaseOrderMainRoute,
    PurchaseOrderProductsRoute,
    PurchaseOrderActivityRoute,
    PurchaseOrderDocumentsRoute,
  ]),
  TransitsRoute,
  TransitDetailRoute,
  ConfigurationRoute.addChildren([ConfigurationIndexRoute, CountryRisksRoute]),
  SettingsRoute,
]);

export type RouteTree = typeof routeTree;
